const DefaultCheckRevenuesPeriodFacts = {
  productionScada: 0,
  productionGrid: 0,
  productionGridCount: 0,
  productionLosses: 0,
  marketPrice: 0,
  tariff: 0,
  scadaRevenue: 0,
  totalRevenue: 0,
  revenueLosses: 0,
  consumptionLosses: 0,
  electricitySalesRevenue: 0,
  incentiveRevenue: 0,
  consumptionGrid: 0,
  PPAElectricityPrice: 0,
  incentive: 0,
  totalTariff: 0,
  realizedPPA: 0,
  PPAElectricityPriceByPark: 0,
  marketPriceRevenues: 0 
};

export class CheckRevenuesPeriodFacts {
  _id: string;
  feName: string;
  lastUpdated: number;
  period: string;
  productionScada: number;
  productionGrid: number;
  productionGridCount: number;
  productionLosses: number;

  marketPrice: number;
  tariff: number;
  referencePrice: number;
  referencePriceRevenues: number;
  scadaRevenue: number;
  totalRevenue: number;
  revenueLosses: number;
  consumptionLosses: number;
  electricitySalesRevenue: number;
  incentiveRevenue: number;
  consumptionGrid: number;
  PPAElectricityPrice: number;
  incentive: number;
  totalTariff: number;
  realizedPPA: number;
  PPAElectricityPriceByPark: number;
  marketPriceRevenues: number;
  neasFee: number;
  statnettFee: number;
  estimatedBalancingFee: number;
  elcertsHedgePrice: number;
  hedgedPpaCapacity: number;
  monthlyPpaVolume: number;
  financialHedge: number;
  powerHedgePrice: number;
  ppaPrice: number;
  riskPremium: number;
  ppaRevenue: number;
  
  constructor(init: Partial<CheckRevenuesPeriodFacts>) {
    Object.assign(this, init);
  }

  static createFromFacts(facts: CheckRevenuesPeriodFacts, hasElectricitySalesRevenue = false, lastUpdated = false): CheckRevenuesPeriodFacts {
    return new CheckRevenuesPeriodFacts(Object.assign({
      productionScada: facts.productionScada,
      productionGrid: facts.productionGrid,
      productionGridCount: facts.productionGridCount,
      productionLosses: Math.max(facts.productionLosses, 0),
      marketPrice: facts.marketPrice,
      tariff: facts.tariff,
      scadaRevenue: facts.scadaRevenue,
      totalRevenue: facts.totalRevenue,
      revenueLosses: facts.revenueLosses,
      consumptionLosses: facts.consumptionLosses,
      electricitySalesRevenue: hasElectricitySalesRevenue ? facts.electricitySalesRevenue : 0,
      incentiveRevenue: facts.incentiveRevenue,
      consumptionGrid: facts.consumptionGrid,
      PPAElectricityPrice: facts.PPAElectricityPrice,
      incentive: facts.incentive,
      totalTariff: facts.totalTariff,
      realizedPPA: facts.realizedPPA,
      PPAElectricityPriceByPark: facts.electricitySalesRevenue / facts.productionGrid,
      marketPriceRevenues: facts.marketPriceRevenues,
    }, lastUpdated ? { lastUpdated: facts.lastUpdated } : {}
    ));
  }
}

export class CheckRevenuesFacts {
  ratedPower: number;
  isGreen: any;
  code?: string;
  feName: string;
  dayTotals: CheckRevenuesPeriodFacts;
  monthTotals: CheckRevenuesPeriodFacts;
  monthEndTotals: CheckRevenuesPeriodFacts;
  yearTotals: CheckRevenuesPeriodFacts;
  yearEndTotals: CheckRevenuesPeriodFacts;
  yearMonthEndTotals: CheckRevenuesPeriodFacts;

  static createEmptyNew() {
    return new CheckRevenuesFacts({
      ratedPower: 0,
      isGreen: false,
      dayTotals: new CheckRevenuesPeriodFacts({
        lastUpdated: -1,
        ...DefaultCheckRevenuesPeriodFacts,
      }),
      monthTotals: new CheckRevenuesPeriodFacts(DefaultCheckRevenuesPeriodFacts),
      monthEndTotals: new CheckRevenuesPeriodFacts(DefaultCheckRevenuesPeriodFacts),
      yearTotals: new CheckRevenuesPeriodFacts(DefaultCheckRevenuesPeriodFacts),
      yearEndTotals: new CheckRevenuesPeriodFacts(DefaultCheckRevenuesPeriodFacts),
      yearMonthEndTotals: new CheckRevenuesPeriodFacts(DefaultCheckRevenuesPeriodFacts),
    });
  }

  

  static mapFromPark(park: any) {
    if (park) {
      const facts = CheckRevenuesFacts.createEmptyNew();
      const hasElectricitySalesRevenue = park.fe_name !== 'Juvent' && park.fe_name !== 'St. Germier';
      const dayTotals = park.dayTotals && CheckRevenuesPeriodFacts.createFromFacts(park.dayTotals, hasElectricitySalesRevenue, true);
      const monthTotals = park.monthTotals && CheckRevenuesPeriodFacts.createFromFacts(park.monthTotals, hasElectricitySalesRevenue);
      const monthEndTotals = park.monthEndTotals && CheckRevenuesPeriodFacts.createFromFacts(park.monthEndTotals, hasElectricitySalesRevenue);
      const yearTotals = park.yearTotals && CheckRevenuesPeriodFacts.createFromFacts(park.yearTotals, hasElectricitySalesRevenue);
      const yearEndTotals = park.yearEndTotals && CheckRevenuesPeriodFacts.createFromFacts(park.yearEndTotals, hasElectricitySalesRevenue);
      const yearMonthEndTotals = park.yearMonthEndTotals && CheckRevenuesPeriodFacts.createFromFacts(park.yearMonthEndTotals, hasElectricitySalesRevenue);

      Object.assign(facts, {
        feName: park.fe_name,
        ratedPower: park.ratedPower.WTUR1_MW_rated.sum,
        isGreen: park.isGreen || park.fe_name === 'Juvent' || (park.country.code === 'DE' && park.fe_name !== 'Bockelwitz') || park.fe_name === 'St. Germier',
        dayTotals,
        monthTotals,
        monthEndTotals,
        yearTotals,
        yearEndTotals,
        yearMonthEndTotals,
      })

      return facts;
    } else {
      return null;
    }
  }

  static mapFromPortfolio(parks: any) {
    const mappedParks: Array<CheckRevenuesFacts> = [];
    parks.forEach((park) => {
      if (park) {
        const facts = CheckRevenuesFacts.createEmptyNew();
        const hasElectricitySalesRevenue = park.fe_name !== 'Juvent' && park.fe_name !== 'St. Germier';
        const monthTotals = park.monthTotals && CheckRevenuesPeriodFacts.createFromFacts(park.monthTotals, hasElectricitySalesRevenue, true);
        const monthEndTotals = park.monthEndTotals && CheckRevenuesPeriodFacts.createFromFacts(park.monthEndTotals, hasElectricitySalesRevenue);
        const yearTotals = park.yearTotals && CheckRevenuesPeriodFacts.createFromFacts(park.yearTotals, hasElectricitySalesRevenue);
        const yearEndTotals = park.yearEndTotals && CheckRevenuesPeriodFacts.createFromFacts(park.yearEndTotals, hasElectricitySalesRevenue);
        const yearMonthEndTotals = park.yearMonthEndTotals && CheckRevenuesPeriodFacts.createFromFacts(park.yearMonthEndTotals, hasElectricitySalesRevenue);
  
        Object.assign(facts, {
          feName: park.fe_name,
          ratedPower: park.ratedPower.WTUR1_MW_rated.sum,
          isGreen: park.isGreen || park.fe_name === 'Juvent' || (park.country.code === 'DE' && park.fe_name !== 'Bockelwitz') || park.fe_name === 'St. Germier',
          monthTotals,
          monthEndTotals,
          yearTotals,
          yearEndTotals,
          yearMonthEndTotals,
        });

        mappedParks.push(facts);
      }
    });
    return mappedParks;
  }

  constructor(init: Partial<CheckRevenuesFacts>) {
    Object.assign(this, init);
  }

}
